import React from 'react';
import { Globe } from 'lucide-react';

export function Header() {
  return (
    <header className="bg-gradient-to-r from-purple-800 to-indigo-900 text-white py-6">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Globe className="h-8 w-8" />
            <span className="text-2xl font-bold">Build Your Online Presence</span>
          </div>
          <nav>
            <ul className="flex space-x-6">
              <li><a href="#bans" className="hover:text-purple-200">Bans</a></li>
              <li><a href="#services" className="hover:text-purple-200">Services</a></li>
              <li><a href="#contact" className="hover:text-purple-200">Contact</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}